import lightbox from './glightbox';

class Videoplayer {
  constructor(node) {
    this.rootElement = node;
    this.videoElement = this.rootElement.querySelector('.c-video-player__container');
    this.videoId = this.videoElement.getAttribute('data-video-id');
    this.videoURL = this.videoElement.getAttribute('data-video-url');
    this.videoElement.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    event.preventDefault();

    lightbox.setElements([
      {
        'content': document.querySelector(`#${this.videoId}`)
      }
    ]);

    const modal = document.querySelector('#glightbox-body');
    if (modal) {

      const confirmButton = document.querySelector('#glightbox-body').querySelector('[data-video-confirm]');
      const dismissButton = document.querySelector('#glightbox-body').querySelector('[data-video-dismiss]');

      if (confirmButton) {
        confirmButton.addEventListener('click', () => {
          event.preventDefault();

          // Replace GDPR content w/ video
          lightbox.setElements([
            {
              'href': this.videoURL,
              'type': 'video',
            }
          ]);
        });
      } else {
        lightbox.setElements([
          {
            'href': this.videoURL,
            'type': 'video',
          }
        ]);
      }

      if (dismissButton) {

        dismissButton.addEventListener('click', () => {
          // Close GDPR lightbox;
          lightbox.close();
        });
      }
    }
  }
}

const videoplayers = document.querySelectorAll('.c-video-player');
videoplayers.forEach((videoplayer) => {
  new Videoplayer(videoplayer);
});
